/* eslint-disable react/prop-types */
/* eslint-disable no-console */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import GetInTouch from '../dashboard/home/getInTouch';
import { getBreakpoint, getLangCodeSelector } from '../../../selectors/commonSelectors';
import ContactUs from '../dashboard/home/contactUs/index.js';
import HeroBanner from '../../../asset/images/our_story/hero_banner_new.png';
import Amay from '../../../asset/images/our_story/amay_shah.png';
import Nidhi from '../../../asset/images/our_story/nidhi_joshi.png';
import Roshan from '../../../asset/images/our_story/roshan_kulkarni.png';
import Photo1 from '../../../asset/images/our_story/photo_1.png';
import Photo2 from '../../../asset/images/our_story/photo_2.png';
import Photo3 from '../../../asset/images/our_story/photo_3.png';
import Photo4 from '../../../asset/images/our_story/photo_4.png';
import Photo5 from '../../../asset/images/our_story/photo_5.png';
import Photo6 from '../../../asset/images/our_story/photo_6.png';
import DesktopImg from '../../../asset/images/our_story/desktop_img.png';
import '../../../asset/styles/bootstrap/bootstrap-grid.min.css';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

class OurStory extends Component {

  constructor (props) {
    super(props);
    this.gotoVisavaWeb = this.gotoVisavaWeb.bind(this);
  }

  gotoVisavaWeb () {
    const jwtToken = localStorage.getItem('jwtToken');
    if (jwtToken) {
      this.props.history.push('/homes');
    } else {
      this.props.history.push('/signup');
    }
  }

  componentDidMount () {
    window.scrollTo({ top: 0 });
  }

  render () {
    const { breakpoint, t, langCode } = this.props;
    const isEn = (langCode || 'en') === 'en';
    return (
      <div className='our_story_main_container banner-container-top'>
        <div className='hero_banner_section'>
          <img src={HeroBanner}
            alt='Visava Story Banner' />
        </div>
        <div className='our_story_content section_padding'>
          <p className='content'>{t('our_story_title')}</p>
          <p className='content'>{t('our_story_first_para')}{t('our_story_second_para')}</p>
          <p className='content'>{t('our_story_third_para')}</p>
        </div>
        <div className='photo_gallery_mobile section_padding'>
          <div className='bootstrap-wrapper'>
            <div className='row no-gutters'>
              <div className='col-md-6'>
                {langCode == 'hi' ?
                  <div className='title'>{t('our_story_forth_para')} <span className='colored'>{t('our_story_fifth_para')}</span></div> :
                  langCode == 'mr' ?
                    <div className='title'>{t('our_story_forth_para')} <span className='colored'>{t('our_story_forth_para_2')}</span> {t('our_story_forth_para_3')}</div> :
                    <div className='title'>{t('our_story_forth_para')} <span className='colored'>{t('our_story_fifth_para')}</span></div> }
                <div className='photo'>
                  <img src={Photo1} />
                </div>
                <div className='photo'>
                  <img src={Photo2} />
                </div>
              </div>
              <div className='col-md-6'>
                <div className='photo'>
                  <img src={Photo3} />
                </div>
                <div className='photo'>
                  <img src={Photo4} />
                </div>
                <div className='photo'>
                  <img src={Photo5} />
                </div>
                <div className='photo'>
                  <img src={Photo6} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='photo_gallery_desktop section_padding'>
          <div className='photo'>
            {langCode == 'hi' ?
              <div className='title'>{t('our_story_forth_para')} <span className='colored'>{t('our_story_forth_para_2')}</span> {t('our_story_forth_para_3')}</div> :
              langCode == 'mr' ?
                <div className='title'>{t('our_story_forth_para')} <span className='colored'>{t('our_story_forth_para_2')}</span> {t('our_story_forth_para_3')}</div> :
                <div className='title'>{t('our_story_forth_para')} <span className='colored'>{t('our_story_fifth_para')}</span></div> }
            <img src={DesktopImg} />
          </div>
        </div>

        <section className='our_story_founders'>
          <h2 className='our_story_founders__heading'>{t('our_story_title_two')}</h2>
          <div className='our_story_founders__grid'>
            <article className='our_story_founder'>
              <div className='our_story_founder__avatar'>
                <img src={Amay}
                  alt={isEn ? 'Amay Shah' : ''} />
              </div>
              <div className='our_story_founder__name'>{t('our_story_founder_amay_name')}</div>
              <div className='our_story_founder__role'>{t('our_story_founder_role')}</div>
              <div className='our_story_founder__bio'>
                <p><span className='our_story_founder__dot'
                  aria-hidden>•</span>{t('our_story_founder_amay_cred_1')}</p>
                <p><span className='our_story_founder__dot'
                  aria-hidden>•</span>{t('our_story_founder_amay_cred_2')}</p>
              </div>
            </article>
            <article className='our_story_founder'>
              <div className='our_story_founder__avatar'>
                <img src={Nidhi}
                  alt={isEn ? 'Nidhi Joshi' : ''} />
              </div>
              <div className='our_story_founder__name'>{t('our_story_founder_nidhi_name')}</div>
              <div className='our_story_founder__role'>{t('our_story_founder_role')}</div>
              <div className='our_story_founder__bio'>
                <p><span className='our_story_founder__dot'
                  aria-hidden>•</span>{t('our_story_founder_nidhi_cred_1')}</p>
                <p><span className='our_story_founder__dot'
                  aria-hidden>•</span>{t('our_story_founder_nidhi_cred_2')}</p>
              </div>
            </article>
            <article className='our_story_founder'>
              <div className='our_story_founder__avatar'>
                <img src={Roshan}
                  alt={isEn ? 'Roshan Kulkarni' : ''} />
              </div>
              <div className='our_story_founder__name'>{t('our_story_founder_roshan_name')}</div>
              <div className='our_story_founder__role'>{t('our_story_founder_role')}</div>
              <div className='our_story_founder__bio'>
                <p><span className='our_story_founder__dot'
                  aria-hidden>•</span>{t('our_story_founder_roshan_cred_1')}</p>
                <p><span className='our_story_founder__dot'
                  aria-hidden>•</span>{t('our_story_founder_roshan_cred_2')}</p>
              </div>
            </article>
          </div>
          <p className='our_story_founders__footnote'>{t('our_story_other_team_members')}</p>
        </section>

        <div className='our_story_cta'>
          <div className='our_story_cta__inner'>
            <p className='our_story_cta__title'>{t('our_story_title_three')}</p>
            <button type='button'
              className='our_story_cta__btn'
              onClick={this.gotoVisavaWeb}>
              {t('vendor_page_button_label')}
            </button>
          </div>
        </div>

        {breakpoint == 'sm' && <ContactUs {...this.props} />}
        <GetInTouch />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  breakpoint : getBreakpoint(state),
  langCode: getLangCodeSelector(state)
});

export default withTranslation()(connect(mapStateToProps, null)(withRouter(OurStory)));
